import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import withStyles from "@material-ui/core/styles/withStyles";
import Table from "@material-ui/core/Table";
import SearchIcon from "@material-ui/icons/Search";
import classNames from "classnames";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import emptylist from "Assets/Svg/illustration-no-policy.svg";
import { CheckActionPermission } from "Actions/commonAction";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import { setHelperText } from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import deleteIcon from "../../../../../../../Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import editIcon from "../../../../../../../Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import DrawerHeader from "../../../../../../../Component/Headers/drawerHeader";
import { getFormattedDate } from "../../../../../../../Utils";
import {
  TDTypeConsts,
  CreateComp,
} from "../../../../../business-configration/commons";
import AddBankDetails from "./AddBankDetails";
import CustomLoader from "Component/CustomLoader";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
  },

  drawerPaper: {
    width: "30%",
  },
});

class BankDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      bankdetails: [],
      allbankdetails: [],
      tempList: [],
      errors: {},
      gridmode: 0,
      headers: [
        {
          key: "bankname",
          name: <FormattedMessage id="LbBankName" defaultMessage="Bank Name" />,
          type: TDTypeConsts.BANK_NAME,
        },
        {
          key: "accounttypename",
          name: (
            <FormattedMessage
              id="LbAccountType"
              defaultMessage="Account Type"
            />
          ),
          type: TDTypeConsts.ACCOUNT_TYPE,
        },
        {
          key: "accountnumber",
          name: (
            <FormattedMessage
              id="LbAccountNumber"
              defaultMessage="Account Number"
            />
          ),
          type: TDTypeConsts.ACCOUNT_NUMBER,
        },
        // { key: 'ifsccode', name: <FormattedMessage id="LbIFSCCode" defaultMessage="IFSC Code" />, type: TDTypeConsts.IFSC_CODE },
        {
          key: "statename",
          name: <FormattedMessage id="LbState" defaultMessage="State" />,
          type: TDTypeConsts.STATE,
        },
        {
          key: "addeddate",
          name: (
            <FormattedMessage
              id="LbCreatedDate"
              defaultMessage="Created Date"
            />
          ),
          type: TDTypeConsts.CREATED_DATE,
        },
        {
          key: "",
          name: <FormattedMessage id="_LbState" defaultMessage="Linked with" />,
          type: TDTypeConsts.STATE,
        },
        {
          key: "edit",
          name: <FormattedMessage id="Lbedit" defaultMessage="Edit" />,
          type: TDTypeConsts.EDIT_WITHOUT_HEADER,
        },
        {
          key: "delete",
          name: <FormattedMessage id="Lbdelete" defaultMessage="Delete" />,
          type: TDTypeConsts.DELETE_WITHOUT_HEADER,
        },
      ],
      permissions: {
        editable: true,
        readonly: false,
      },
      open: false,
      searchValue: "",
    };

    this.onEdit = this.onEdit.bind(this);
    this.onCreateBankDetails = this.onCreateBankDetails.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onClose = this.onClose.bind(this);
    this.GetAllBankDetails = this.GetAllBankDetails.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("bankdetails");
    if (isTrue) {
      this.setState({ permissions }, () => {
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.EDIT_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
        if (!this.state.permissions.editable) {
          const index = this.state.headers.findIndex(
            (x) => x.type == TDTypeConsts.DELETE_WITHOUT_HEADER,
          );
          if (index != -1) {
            this.state.headers.splice(index, 1);
          }
        }
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  componentWillMount() {
    this.props.ChangeLanguage("configpayroll,navigation");
    this.GetAllBankDetails();
  }

  componentWillReceiveProps(props) {
    if (props.match.path == "/subscription/payroll/configpayroll/1") {
      this.GetAllBankDetails();
    }
  }

  ConfirmDelete(id) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            this.DeleteBankDetails(id);
          }}
        >
          Yes
        </Button>,
        <Button
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  DeleteBankDetails(id) {
    const that = this;
    instance.delete(`payroll/deletesubbankdetail/${id}`).then(
      () => {
        this.props.enqueueSnackbar("Deleted Succesfully", {
          variant: "success",
        });
        this.setState(
          {
            allbankdetails: [],
            offset: 0,
          },
          () => {
            that.GetAllBankDetails();
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  GetAllBankDetails() {
    const URL = "employee/getsubscriptionallbankdetail";
    this.setState({isloading:true}, () => {

   this.setState({isloading: true},  () => {

  
    instance
      .post(URL)
      .then((result) => {
        let allbankdetails = [];
        let gridmode = 1;
        result.data.result.length > 0
          ? (allbankdetails = result.data.result)
          : (gridmode = 0);
        const tempList = allbankdetails;
        this.setState({ allbankdetails, tempList, gridmode, data: true, isloading: false });
      })
      .catch((error) => {
        this.setState({ allbankdetails: [], data: true, isloading: false });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
    })
    })
  }

  onEdit = async (bankid) => {
    // const bank = this.state.allbankdetails && this.state.allbankdetails.find((bank) => bank.bankid == bankid);
    let bank = await instance.get(`/payroll/getsubscriptionbanking/${bankid}`);
    console.log("bank: ", bank);
    bank = get(bank, "data.result[0]", "");
    console.log("bank: ", bank);
    this.setState({
      open: true,
      bank,
    });
  };

  onCreateBankDetails() {
    this.setState({
      open: !this.state.open,
      bank: null,
    });
  }

  onClose() {
    this.setState({
      open: false,
      bank: null,
    });
  }

  onSearch(e) {
    if (e.target.value != "") {
      const allbankdetails = this.state.tempList.filter(
        (bank) =>
          bank.bankname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({ searchValue: e.target.value, allbankdetails });
    } else {
      this.setState({
        searchValue: e.target.value,
        allbankdetails: this.state.tempList,
      });
    }
  }

  render() {
    const { classes } = this.props;
    const goTo = (path) => {
      this.props.history.push(path);
    };

    const language = this.props.Language.configpayroll;
    return (
      <IntlProvider locale="en" messages={language}>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            {this.state.isloading ? 
             <div> <CustomLoader /></div>
           : <div>
              {this.state.allbankdetails &&
              this.state.allbankdetails.length > 0 ? (
                <Grid container>
                  <Grid container className="margin-bottom-8">
                    <Grid item xs={12} md={12} sm={12}>
                      <Grid container justify="flex-end" direction="row">
                        <div style={{ marginRight: 20 }}>
                          {/* <div className={classes.searchIcon}>
                                                <SearchIcon />
                                            </div>
                                            <Input
                                                placeholder="Search"
                                                disableUnderline
                                                value={this.state.searchValue}
                                                fullWidth
                                                className="master-seach"
                                                onChange={this.onSearch}
                                            /> */}
                          <FormControl className="searchBox payroll-bank-details-search">
                            <Input
                              placeholder="Search"
                              disableUnderline
                              value={this.state.searchValue}
                              fullWidth
                              // className="master-seach"
                              style={{ height: 33 }}
                              onChange={this.onSearch}
                              startAdornment={
                                <InputAdornment position="start">
                                  <SearchIcon color="disabled" />
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                        </div>
                        {this.state.permissions.editable && (
                          <Grid>
                            <Button
                              variant="contained"
                              color="primary"
                              type="button"
                              className="btn btn-primary-md-blue"
                              onClick={this.onCreateBankDetails}
                            >
                              Create
                            </Button>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container className="">
                    <Grid item xs={12} md={12} sm={12}>
                      <div className="table-status">
                        {this.state.allbankdetails &&
                          this.state.allbankdetails.length > 0 &&
                          `Showing all ${
                            this.state.allbankdetails &&
                            this.state.allbankdetails.length
                          } banks`}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12} md={12} sm={12}>
                      <Table className="approvalWorkflow-table">
                        <thead>
                          <tr>
                            {this.state.headers.map((header) => (
                              <th style={{textAlign:"left"}}>{header.name}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.allbankdetails &&
                            this.state.allbankdetails.map((bank) => (
                              <tr>
                                <td style={{textAlign:"left"}}>
                                  <span>{bank.bankname}</span>
                                </td>
                                <td style={{textAlign:"left"}}>
                                  <span>{bank.accounttypename}</span>
                                </td>
                                <td style={{textAlign:"left"}}>
                                  <span>{bank.accountnumber}</span>
                                </td>
                                <td style={{textAlign:"left"}}>
                                  {/* <span>-</span> */}
                                  <span>{bank.statename}</span>
                                </td>
                                <td style={{ width: "15%", textAlign:"left" }}>
                                  <span>
                                    {bank.addeddate &&
                                      getFormattedDate(bank.addeddate)}
                                  </span>
                                </td>
                                <td style={{ width: "18%", textAlign:"left" }}>
                                  {bank.ispayrolllinked && (
                                    <span
                                      style={{
                                        padding: "4px 8px",
                                        backgroundColor: "#E2F1FF",
                                        color: "#166ab3",
                                        borderRadius: 30,
                                        marginRight: 4,
                                        fontSize: "14px"
                                      }}
                                    >
                                      {" "}
                                      Payroll
                                    </span>
                                  )}
                                  {bank.isexpenselinked && (
                                    <span
                                      style={{
                                        padding: "4px 8px",
                                        backgroundColor: "#E2F1FF",
                                        color: "#166ab3",
                                        borderRadius: 30,
                                        fontSize: "14px"
                                      }}
                                    >
                                      {" "}
                                      Expense
                                    </span>
                                  )}
                                </td>
                                {this.state.permissions &&
                                  this.state.permissions.editable && (
                                    <td className="position-rel">
                                      <img
                                        src={editIcon}
                                        className="cursour-pointer vertical-middle"
                                        onClick={() =>
                                          this.onEdit(bank.subscriptionbankid)
                                        }
                                      ></img>
                                    </td>
                                  )}
                                {this.state.permissions &&
                                  this.state.permissions.editable && (
                                    <td>
                                      <img
                                        src={deleteIcon}
                                        className="cursour-pointer vertical-middle"
                                        onClick={() =>
                                          this.ConfirmDelete(
                                            bank.subscriptionbankid,
                                          )
                                        }
                                      ></img>
                                    </td>
                                  )}
                              </tr>
                            ))}
                        </tbody>
                      </Table>
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <div className="content-outer-wrapper">
                  <CreateComp
                    text="There are no bank details to display yet!"
                    heading="Add a bank account to get started"
                    onCreate={this.onCreateBankDetails}
                    imageSrc={emptylist}
                    permissions={this.state.permissions}
                  />
                </div>
              )}
            </div>
            }
            <Drawer
              anchor="right"
              open={this.state.open}
              onClose={this.onCreateBankDetails}
              classes={{
                paper: classNames(classes.drawerPaper, "planner-drawer"),
              }}
            >
              <div className="planner-right-drawer">
                <DrawerHeader
                  header="Add bank details"
                  isbackarrow={false}
                  closeDrawer={() => this.setState({ open: false })}
                />
                {this.state.open && (
                  <AddBankDetails
                    {...this.props}
                    bank={this.state.bank}
                    goTo={goTo}
                    onClose={this.onClose}
                    GetAllBankDetails={this.GetAllBankDetails}
                  />
                )}
              </div>
            </Drawer>
          </div>
        )}
      </IntlProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(BankDetails)));

// export default BankDetails;
